export default __webpack_public_path__ + "static/media/img_step_lucia03-08.084da3f4.jpg";